// 引入全局组件
import titleBox from "@/components/titleBox";
import validCode from "@/components/validCode";

const plugin = {
  install(Vue) {
    Vue.component(titleBox.name, titleBox);
    Vue.component(validCode.name, validCode);
  },
};

export default plugin;
